<template>
  <el-table
    :data="tableData"
    height="100%"
    border
    stripe
    style="width: 96%; margin: 0 auto"
    :header-cell-style="{
      'font-weight': 'bold',
      color: '#333',
      'background-color': '#F7F7F7',
    }"
    size="small"
    :cell-style="cellStyle"
    @cell-click="cellClick"
  >
    <el-table-column
      v-for="(v, i) in tabHead"
      :key="i"
      :prop="v.prop"
      :label="v.label"
      :min-width="flexWidth(v.prop, tableData, v.label)"
      :show-overflow-tooltip="true"
      align="center"
    >
      <template slot-scope="scope">
        <span v-if="scope.row[v.prop] && v.prop == 'handleUser'">
          <el-link
            type="primary"
            v-for="(item, index) in scope.row.assignStaffInfo"
            :key="item.userId"
            @click="toUserPage(item)"
            >{{
              index == scope.row.assignStaffInfo?.length - 1
                ? item.userName
                : `${item.userName}、`
            }}</el-link
          >
        </span>
        <span v-else>{{ scope.row[v.prop] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  flexWidth,
  matchingOrderStatus,
  matchingOrderLevel,
  matchingOrderColor,
  formatTime,
} from "@/assets/js/utils";
export default {
  data() {
    return {
      tableData: [],
      tabHead: [
        { label: "工单ID", prop: "id" },
        { label: "工单名称", prop: "description" },
        { label: "工单级别", prop: "level" },
        { label: "地点", prop: "location" },
        { label: "处理状态", prop: "state" },
        { label: "处理人", prop: "handleUser" },
        { label: "处理时长", prop: "time" },
      ],
    };
  },
  methods: {
    flexWidth,
    toUserPage(data) {
      this.$router.push({
        name: "authority",
        params: { userId: data.userId },
      });
    },
    cellStyle(row) {
      if (row.column.label === "工单级别") {
        return matchingOrderColor(row.row.level);
      }
      if (row.column.label === "工单ID" || row.column.label === "工单名称") {
        return "color:#28CCCB;cursor: pointer;";
      }
    },
    cellClick(row, column) {
      if (column.label == "工单ID" || column.label === "工单名称") {
        this.$router.push({
          path: "/worksheets",
          query: { id: row.id },
        });
      }
    },
    async getTable() {
      let res = await api.controlGetWorkOrder({
        pageSize: 10000,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data.data;
        this.tableData.map((v) => {
          v.handleUser = v.assignStaffNames.join("、");
          v.state = matchingOrderStatus(v.status);
          v.level = matchingOrderLevel(v.priority);
          v.time = v.ts ? formatTime(v.ts) : "-";
        });
      }
    },
  },
  created() {
    this.getTable();
  },
};
</script>

<style lang="scss" scoped></style>
